import {
  Component,
  ViewEncapsulation,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import * as moment from 'moment';
import {ApiService} from '../services/api';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-register',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'register.template.html',
  styleUrls: [
    './register.style.scss'
  ]
})

export class RegisterComponent implements OnInit {
  public form: FormGroup;

  accountId:string;
  locationId:string;
  loading = false;
  registered = false;
  providers:any[];
  location:string;
  telehealth = false;
  countries = ['USA', 'CAD'];
  slots = ['morning','afternoon', 'evening'];
  genders = [{label: 'Male', value: 'm'}, {label:'Female', value: 'f'}];

  constructor(private formBuilder: FormBuilder,
              private api: ApiService,
              private route: ActivatedRoute,
              private snackBar: MatSnackBar,
              private changeDetect: ChangeDetectorRef) {
    this.accountId = this.route.snapshot.paramMap.get('account');
    this.locationId = this.route.snapshot.paramMap.get('location');

    this.api.get<any>(`/register/${this.accountId}/${this.locationId}`)
      .subscribe(result => {
        this.providers = result.providers;
        this.location = result.name
      });

  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public ngOnDestroy(): void {
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      lastName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2)
      ]),
      firstName: new FormControl(null, [
        Validators.required,
        Validators.minLength(2)
      ]),
      email: new FormControl(null, [
        Validators.required,
        Validators.email,
        Validators.minLength(3)
      ]),
      dob: new FormControl(null, [
        Validators.required
      ]),
      gender: new FormControl(null, [
        Validators.required
      ]),
      occupation: new FormControl(null, [
      ]),
      address: new FormControl(null, [
      ]),
      address2: new FormControl(null, [
      ]),
      postal: new FormControl(null, [
      ]),
      city: new FormControl(null, [
      ]),
      region: new FormControl(null, [
      ]),
      country: new FormControl(null, [
      ]),
      phone: new FormControl(null, [
        Validators.required,
        Validators.minLength(10)
      ]),
      agree: new FormControl(null, [
        Validators.required,
        Validators.requiredTrue
      ]),
      height: new FormControl(null, [
      ]),
      weight: new FormControl(null, [
      ]),
      shoe: new FormControl(null, [
      ]),
      user_id: new FormControl(null, [
      ]),
      when: new FormControl(moment().add(1, 'day').toDate(), [
      ]),
      slot: new FormControl('morning', [
      ]),
      subject: new FormControl(null, [
      ]),
      confirmed: new FormControl(null, [
      ]),
    });
  }

  public toggleTelehealthFields() {
    this.telehealth = !this.telehealth;
    console.log("Toggled telehealthfields to : " + this.telehealth);
    if( this.telehealth ) {
      this.form.get('when').setValidators([Validators.required]);
      this.form.get('subject').setValidators([Validators.required]);
    } else {
      this.form.get('when').clearValidators();
      this.form.get('subject').clearValidators();
    }
    this.form.get('when').updateValueAndValidity();
    this.form.get('subject').updateValueAndValidity();
    this.changeDetect.detectChanges();
  }

  public save() {
    let biometric:any = {};
    biometric.height = this.form.value.height;
    if( biometric.height )
      biometric.heightUnits = 'in';
    biometric.weight = this.form.value.weight;
    if( biometric.weight )
      biometric.weightUnits = 'lb';
    biometric.shoe = this.form.value.shoe;
    if( biometric.shoe )
      biometric.shoeUnits = 'US';
    let client:any = Object.assign({}, {
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName,
      email: this.form.value.email,
      phone: this.form.value.phone,
      dob: this.form.value.dob.toISOString(),
      address: this.form.value.address,
      address2: this.form.value.address2,
      city: this.form.value.city,
      region: this.form.value.region,
      country: this.form.value.country,
      occupation: this.form.value.occupation,
      gender: this.form.value.gender,
      biometric: biometric
    });

    client.account_id = this.accountId;
    client.location_id = this.locationId;

    if( this.telehealth ) {
      client.telehealth = {
        user_id: this.form.value.user_id,
        when: this.form.value.when.toISOString(),
        subject: this.form.value.subject,
        confirmed: !!this.form.value.confirmed
      };
      if( this.form.value.slot === 'morning') {
        client.telehealth.when = moment(client.telehealth.when).set('hour', 9).startOf('hour').toISOString();
      } else if( this.form.value.slot === 'afternoon') {
        client.telehealth.when = moment(client.telehealth.when).set('hour', 12).startOf('hour').toISOString();
      } else if( this.form.value.slot === 'evening') {
        client.telehealth.when = moment(client.telehealth.when).set('hour', 6).startOf('hour').toISOString();
      }

      if( this.form.value.user_id) {
        client.telehealth.user_id = this.form.value.user_id;
      }
    }

    this.api.post<any>(`/register/${this.accountId}/${this.locationId}`, client).subscribe( result => {
      this.registered = true;
      this.snackBar.open('Registered Successfully', null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Registered Error: ${error}`, null, {
        duration: 2000
      });
    });
  }
}
